/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './StepIndicator.css';


const StepIndicator = (props) => {
    const {
        currentStep,
        totalStep,
        stepTitle,
        stepInfo
    } = props;
    return (
        <div className="step-indicator">
            <div className="step-indicator-title">
                <span className="title">{stepTitle}</span>|
                <span className="step">
                    <FormattedMessage
                        id="app.step.indicator"
                        defaultMessage={stepInfo}
                        values={{ currentStep,
                                  totalStep
                                }}
                    />
                </span>
            </div>
            <div className="step-indicator-progress">        
                <div className="step-indicator-progress-bar" style={{ left: -(1-currentStep/totalStep)*100+"%" }}></div>
            </div>
        </div>
    )
};

StepIndicator.propTypes = {
    currentStep: PropTypes.number,
    totalStep: PropTypes.number,
    stepTitle: PropTypes.string,
    stepInfo: PropTypes.string
};

StepIndicator.defaultProps = {
    totalStep: 5
};

export default StepIndicator;


// WEBPACK FOOTER //
// ./src/shared/StepIndicator/components/StepIndicator.js